<template>
  <div class="page">
    <template v-if="!ismobile">
      <div class="header flex space_between align_center">
        <img src="../assets/images/logo.png" alt="" style="width: 180px" />
        <div v-if="state.data.nickname" class="user">
          <span>{{ state.data.nickname }}</span>
          <span @click="logout" style="color: #6366f9">退出</span>
        </div>
        <div v-else>
          <el-button @click="toLogin(0)" round plain color="#5d65ff"
            >登录 Log in</el-button
          >
          <el-button @click="toLogin(1)" round plain color="#5d65ff"
            >注册 Sign up</el-button
          >
        </div>
      </div>
      <div class="container">
        <div class="main">
          <div class="flex space_between" style="align-items: flex-end">
            <div style="width: 45%">
              <img src="../assets/images/theme.png" alt="" style="width: 70%" />
              <p>
                欢迎来到魔法英语背单词，这里不仅仅是学习，而是一场英语词汇的革命!我们结合艾宾浩斯记忆曲线和最新的智慧脑科学研究成果为你打造的一套科学的记忆法，能帮助你使用短短三十天学会三年的英语单词，形成长期记忆，
              </p>
              <el-button
                color="#fb6401"
                @click="onStart"
                style="color: #fff"
                round
                size="large"
                >立即体验<el-icon class="el-icon--right"> <Right /> </el-icon
              ></el-button>
              <br />
              <br />
            </div>

            <div style="width: 45%">
              <img
                src="../assets/images/people.png"
                alt=""
                style="width: 80%"
              />
            </div>
          </div>

          <div class="flex space_between">
            <div style="width: 45%">
              <div class="main_module1">
                <h3>
                  <img
                    class="vertical"
                    src="../assets/images/icon1.png"
                    alt=""
                    width="60"
                  />我们的魔法配方
                </h3>

                <span>艾宾浩斯记忆曲线</span>
                <p>根据记忆曲线安排复习计划，让单词记忆更持久。</p>
                <span>循环记忆机制</span>
                <p>通过循环记忆法，加强大脑对单词的记忆痕迹。</p>
                <span>脑科学支持</span>
                <p>利用脑科学原理，激发你的大脑潜能，提高记忆效率。</p>
              </div>
            </div>
            <div style="width: 45%">
              <div class="main_module2">
                <h3>
                  <img
                    class="vertical"
                    src="../assets/images/icon2.png"
                    alt=""
                    width="60"
                  />快速学习，长期记忆
                </h3>

                <span>个性化学习路径</span>
                <p>根据你的学习习惯和记忆能力，定制个性化学习计划。</p>
                <span>互动式学习体验</span>
                <p>通过互动式学习，让背单词变得生动有趣。</p>
                <span>智能复习系统</span>
                <p>智能算法自动安排复习，巩固记忆，避免遗忘。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="m_bg">
        <div class="m_header flex space_between align_center">
          <img src="../assets/images/logo.png" alt="" style="width: 40%" />
          <div v-if="state.data.nickname" class="user">
            <span>{{ state.data.nickname }}</span>
            <span @click="logout" style="color: #6366f9">退出</span>
          </div>
          <div v-else>
            <el-button @click="toLogin(0)" round plain color="#5d65ff"
              >登录</el-button
            >
            <el-button @click="toLogin(1)" round plain color="#5d65ff"
              >注册</el-button
            >
          </div>
        </div>
        <div class="m_container text_center">
          <br />
          <img src="../assets/images/theme.png" alt="" style="width: 90%" />
          <p>
            <br />
            欢迎来到魔法英语背单词，这里不仅仅是学习，而是一场英语词汇的革命!我们结合艾宾浩斯记忆曲线和最新的智慧脑科学研究成果为你打造的一套科学的记忆法，能帮助你使用短短三十天学会三年的英语单词，形成长期记忆，
          </p>
          <el-button
            color="#fb6401"
            @click="onStart"
            style="color: #fff; width: 100%"
            round
            size="large"
            >立即{{ state.data.nickname ? "开始" : "体验"
            }}<el-icon class="el-icon--right"> <Right /> </el-icon
          ></el-button>
          <br />
          <br />
          <div class="main_module1">
            <h3>我们的魔法配方</h3>
            <span>艾宾浩斯记忆曲线</span>
            <p>根据记忆曲线安排复习计划，让单词记忆更持久。</p>
            <span>循环记忆机制</span>
            <p>通过循环记忆法，加强大脑对单词的记忆痕迹。</p>
            <span>脑科学支持</span>
            <p>利用脑科学原理，激发你的大脑潜能，提高记忆效率。</p>
          </div>
          <div class="main_module2">
            <h3>快速学习，长期记忆</h3>
            <span>个性化学习路径</span>
            <p>根据你的学习习惯和记忆能力，定制个性化学习计划。</p>
            <span>互动式学习体验</span>
            <p>通过互动式学习，让背单词变得生动有趣。</p>
            <span>智能复习系统</span>
            <p>智能算法自动安排复习，巩固记忆，避免遗忘。</p>
          </div>
        </div>
      </div>
    </template>

    <el-dialog v-model="loginShow" title="" :width="ismobile ? '90%' : '30%'">
      <div class="text_center login">
        <h2 style="color: #6366f9">魔法英语背单词</h2>
        <el-form ref="formRef" :model="form" label-width="80px">
          <el-form-item
            label="姓名"
            prop="nickName"
            :rules="[
              {
                required: true,
                message: '请输入姓名',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              style="width: 100%"
              v-model="form.nickName"
              placeholder="请输入姓名"
              size="large"
            />
          </el-form-item>
          <el-form-item
            label="手机号"
            prop="phone"
            :rules="[
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              style="width: 100%"
              v-model="form.phone"
              placeholder="请输入手机号"
              size="large"
            />
          </el-form-item>
          <el-form-item
            label="验证码"
            prop="code"
            :rules="[
              {
                required: true,
                message: '请输入验证码',
                trigger: 'blur',
              },
            ]"
          >
            <el-row style="width: 100%">
              <el-col :span="14">
                <el-input
                  style="width: 100%"
                  v-model="form.code"
                  placeholder="请输入验证码"
                  size="large"
              /></el-col>
              <el-col :span="10">
                <el-button size="large" @click="getCode">{{
                  sendCon
                }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <br />

          <el-button
            style="width: 100%"
            color="#6366F9"
            @click="onSubmit(formRef)"
            size="large"
            round
            :loading="loading"
            >登录</el-button
          >
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { reactive, ref, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { post, get } from "../request/post";
const router = useRouter();
const formRef = ref();
const form = ref({});
const loading = ref(false);
const ismobile = ref(false);
const sendCon = ref("获取验证码");
const isCode = ref(false);
const loginShow = ref(false);
const timer = ref(null);
const state = reactive({
  data: {},
});
onMounted(() => {
  state.data = localStorage.getItem("data")
    ? JSON.parse(localStorage.getItem("data"))
    : {};
  ismobile.value = isMobile();
  function isMobile() {
    let userAgent = navigator.userAgent;
    return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  }
});
const toLogin = (type) => {
  router.push({ name: "Login", params: { type: type } });
};
const onStart = () => {
  if (localStorage.getItem("data")) {
    router.push({ name: "Word" });
  } else {
    loginShow.value = true;
  }
};
const onSubmit = async () => {
  if (!formRef) return;
  formRef.value.validate((valid) => {
    if (valid) {
      loading.value = true;
      Login();
    }
  });
};
const Login = async () => {
  const { data, code, msg } = await post("/mf/login", form.value);
  // loading.value = false;
  if (code == 200) {
    console.log(data);
    localStorage.setItem("data", JSON.stringify(data));
    router.push({
      name: "Word",
    });
  } else {
    ElMessage.error(msg);
    return;
  }
};
const getCode = async () => {
  if (!form.value.phone) {
    return false;
  }
  if (isCode.value) {
    return;
  }
  isCode.value = true;
  const { data, code, message } = await post("/mf/send_code", {
    phone: form.value.phone,
  });
  isCode.value = false;
  if (code == 200) {
    ElMessage.success("发送成功");
    countdown();
  } else {
    ElMessage.error(message);
  }
};
const countdown = () => {
  const TIME_COUNT = 60;
  let count = 0;
  if (!timer.value) {
    count = TIME_COUNT;
    timer.value = setInterval(() => {
      if (count > 0 && count <= TIME_COUNT) {
        isCode.value = true;
        count--;
        sendCon.value = `${count}秒后再次获取`;
      } else {
        isCode.value = false;
        clearInterval(timer.value);
        timer.value = null;
        sendCon.value = "获取验证码";
      }
    }, 1000);
  }
};
const logout = () => {
  ElMessageBox.confirm("确认要退出吗？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    localStorage.clear();
    router.push({
      name: "Login",
    });
  });
};
</script>

<style lang="less" scoped>
.header {
  padding: 15px 18%;
  height: 5vh;
  .el-button {
    margin: 0 10px;
    background: #fff;
    color: #6366f9;
  }
}

.container {
  height: 95vh;
  padding: 20px 0;
  background: url("../assets/images/bg.jpg");
  background-size: 100% 100%;

  .main {
    margin: 0 18%;
  }
  p {
    text-align: left;
    line-height: 36px;
  }
}

.vertical {
  vertical-align: middle;
}

.main_module1 {
  padding: 10px 30px 20px 30px;
  background: url("../assets/images/box1.png") no-repeat;
  background-size: 100% 100%;

  span {
    color: #fb6401;
  }
  p {
    margin: 10px 0;
  }
}

.main_module2 {
  padding: 10px 30px 20px 30px;
  background: url("../assets/images/box2.png") no-repeat;
  background-size: 100% 100%;
  span {
    color: #5d65ff;
  }
  p {
    margin: 10px 0;
  }
}
.user {
  span {
    margin: 0 20px;
    cursor: pointer;
  }
}

.m_bg {
  background: url("../assets/images/m_bg.jpg");
  background-size: 100% 100%;
  min-height: 100vh;
  padding-bottom: 20px;
}
.m_header {
  padding: 20px;
}
.m_container {
  width: 90%;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.el-dialog {
  background: linear-gradient(to bottom, #eaebff 0%, #fcfdff 100%);
  border-radius: 16px;
  padding: 0 50px;
}
</style>
